'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;

function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return {
      position: ['-webkit-sticky', 'sticky']
    };
  }
}

module.exports = exports['default'];